import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import { formatCurrency } from 'js/services/Format';
import { validatePrice } from 'js/services/Regex';

import AvInput from '../AvInput';
import AvGroup from '../AvGroup';
import EditDisplay from '../EditDisplay';
import SaveButton from '../SaveButton';
import PriceDisplay from './PriceDisplay';

@inject('page')
@observer
export default class PriceEditor extends Component {
  @observable isEditing = false;
  @action openEditor = () => (this.isEditing = true);
  @action closeEditor = () => (this.isEditing = false);

  render() {
    const page = this.props.page;
    return (
      <AvForm onValidSubmit={this.closeEditor}>
        {this.isEditing ? (
          <AvGroup>
            <AvInput
              name="price"
              type="number"
              value={page.price}
              onChange={page.setPrice}
              validate={validatePrice}
              required
              autoFocus
            />
            <SaveButton>save</SaveButton>
          </AvGroup>
        ) : (
          <EditDisplay onClick={this.openEditor}>
            <PriceDisplay>{formatCurrency(page.price)}</PriceDisplay>
          </EditDisplay>
        )}
      </AvForm>
    );
  }
}
